import React, { useState } from 'react';
import { useHistory } from 'react-router';

import Button from '@material-ui/core/Button/Button';
import { CircularProgress } from '@material-ui/core';

import logo from '../../assets/img/logo-full.png';
import '../../assets/css/login.css';

import { useDispatch, useSelector } from 'react-redux';
import * as authActions from '../../store/actions/authActions';
import { Fragment } from 'react';
import AlertError from './AlertError';

const ChangePassword = () => {
    const [password, setPassword] = useState('');
    const [isLoading, SetIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const userProfile = useSelector(state => state.profile.userProfile);

    const dispatch = useDispatch();

    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        SetIsLoading(true);
        dispatch(authActions.authChangePassword(userProfile.userId, password))
            .then(() => {
                history.push('/');
            })
            .catch(() => {
                SetIsLoading(false);
                setShowError(true);
                setErrorMessage('Invalid Password Entered');
            });
    };

    const renderButtons = () => {
        return (
            <Fragment>
                <button name="login" id="login" className="welcome-btn" type="submit">Change Password</button>
            </Fragment>
        );
    }
    return (
        <div className="main-container">
            <div className="welcome-container">

                <img className="welcome-logo" src={logo} />

                <h2 className="welcome-title">Welcome Back</h2>

                <div className="welcome-form">
                    {showError ? <AlertError message={errorMessage} /> : null}

                    <form onSubmit={handleSubmit}>

                        <label htmlFor="password">Password must be 8 characters</label>
                        <input 
                            type="password" 
                            name="password" 
                            id="password" 
                            className="welcome-field" 
                            placeholder="New Password"
                            onChange={e => setPassword(e.target.value)} />
                        
                        {isLoading ? <CircularProgress /> : renderButtons()}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;
